import type { DayOfWeek, LocationHours } from '@/lib/services/locations/locations.types'

export const DAYS_OF_WEEK = [
  { id: 0, name: 'Sunday' },
  { id: 1, name: 'Monday' },
  { id: 2, name: 'Tuesday' },
  { id: 3, name: 'Wednesday' },
  { id: 4, name: 'Thursday' },
  { id: 5, name: 'Friday' },
  { id: 6, name: 'Saturday' },
] satisfies { id: number; name: DayOfWeek }[]

export const getDefaultHours = (): LocationHours[] => {
  return DAYS_OF_WEEK.map((day) => ({
    id: day.id,
    name: day.name,
    open: '09:00',
    close: '17:00',
    is_open: day.id !== 0, // Default Sunday to closed
  }))
}
